export const MULTI_ACT_CREATE_ACTS = 'MULTI_ACT_CREATE_ACTS';
export const MULTI_ACT_CREATE_ACTS_START = 'MULTI_ACT_CREATE_ACTS_START';
export const MULTI_ACT_CREATE_ACTS_ERROR = 'MULTI_ACT_CREATE_ACTS_ERROR';
